import { useSelector } from "react-redux";

export const useContent = () => {
  const content = useSelector(state => state.content?.content);

  const store = content?.store || {};
  const isDataLoaded = content?.isDataLoaded || false;
  const isLoading = content?.isLoading || false;
  const isFetchError = content?.isFetchError || false;

  const countryInfo = useSelector(state => state.content?.countryInfo || {});

  return { store, isDataLoaded, isLoading, isFetchError, countryInfo };
};
